import { render, staticRenderFns } from "./104whsylcyh.vue?vue&type=template&id=70bb6108&"
import script from "./104whsylcyh.vue?vue&type=script&lang=js&"
export * from "./104whsylcyh.vue?vue&type=script&lang=js&"
import style0 from "./104whsylcyh.vue?vue&type=style&index=0&id=70bb6108&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports